import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { PawPrint, ShoppingBag, CalendarHeart, User, LogOut, LayoutDashboard } from "lucide-react";
import { useAuth, isStaff } from "../context/AuthContext";
import { Button } from "../components/ui/button";

export default function PublicLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const linkCls = ({ isActive }) =>
    `text-sm font-medium transition-colors hover:text-[#0E7C84] ${isActive ? "text-[#0E7C84]" : "text-slate-600"}`;

  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 z-40 bg-[#F2FBFB]/95 backdrop-blur border-b border-[#BFE8E9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
            <img src="/logo-icon.png" alt="Pet's Pantry logo" className="w-10 h-10 rounded-xl" />
            <span className="font-display font-bold text-lg text-[#0E7C84]">Pet's <span className="text-[#06B6D4]">Pantry</span></span>
          </Link>
          <nav className="hidden sm:flex items-center gap-6">
            <NavLink to="/shop" className={linkCls} data-testid="nav-shop">Shop</NavLink>
            <NavLink to="/book" className={linkCls} data-testid="nav-book">Book Grooming &amp; Boarding</NavLink>
            <NavLink to="/about" className={linkCls} data-testid="nav-about">About Us</NavLink>
            {user && isStaff(user) && (
              <NavLink to="/staff" className={linkCls} data-testid="nav-staff">
                <span className="inline-flex items-center gap-1"><LayoutDashboard className="w-4 h-4" /> Staff Console</span>
              </NavLink>
            )}
          </nav>
          <div className="flex items-center gap-2">
            {user ? (
              <>
                <Button variant="outline" size="sm" onClick={() => navigate(isStaff(user) ? "/staff" : "/portal")} data-testid="nav-account-btn">
                  <User className="w-4 h-4 mr-1" /> {isStaff(user) ? "Console" : "My Portal"}
                </Button>
                <Button variant="ghost" size="sm" onClick={handleLogout} data-testid="nav-logout-btn">
                  <LogOut className="w-4 h-4" />
                </Button>
              </>
            ) : (
              <Button size="sm" className="bg-[#0E7C84] hover:bg-[#093F46]" onClick={() => navigate("/login")} data-testid="nav-login-btn">
                Sign In
              </Button>
            )}
          </div>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="bg-[#093F46] text-emerald-50/80 mt-16">
        <div className="max-w-7xl mx-auto px-6 py-10 grid sm:grid-cols-3 gap-8">
          <div>
            <img src="/logo-wide.png" alt="Pet's Pantry — Supplies & Grooming" className="h-16 rounded-xl mb-3" />
            <p className="text-sm">Pet supplies, grooming studio &amp; boarding suites — all under one tropical roof.</p>
          </div>
          <div className="text-sm space-y-2">
            <p className="font-semibold text-white flex items-center gap-2"><ShoppingBag className="w-4 h-4" /> Visit Us</p>
            <p>2nd Floor Plaza Deal Rosa Bldg., Mañalac Avenue, North Dang-Hari, Taguig City 1630</p>
            <p>+63 997 230 0944 · Open daily 9AM–6PM</p>
          </div>
          <div className="text-sm space-y-2">
            <p className="font-semibold text-white flex items-center gap-2"><CalendarHeart className="w-4 h-4" /> Follow Us</p>
            <p>Facebook: Pet's Pantry · TikTok: Pet's Pantry</p>
            <p>Instagram: @petspantry</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
